// Path: ./src/app/pages/Tags/styled.ts
import styled, { css } from "styled-components";
import { Button, ButtonProps, styled as MuiStyled } from "@mui/material";

export const ColorButton = MuiStyled(Button)<ButtonProps>(() => ({
  backgroundColor: "#f58220",
  textTransform: "capitalize",
  fontSize: 18,
  "&:hover": {
    backgroundColor: "#f58220",
  },
  borderRadius: "0.5rem",
  width: "15rem",
}));

export const Container = styled.div`
  width: 100%;
  height: 100%;

  margin-top: 65px;
`;

export const TagHeading = styled.div`
  background: linear-gradient(90deg, #f5f5f5 0%, #ffffff 100%);
  height: 2.25rem;
  padding: 0 0.75rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 600;
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  border-radius: 8px;
  position: sticky;
  top: 0;
  z-index: 2;
  backdrop-filter: blur(4px);
`;

export const CountBadge = styled.span`
  background: #e0e0e0;
  color: #424242;
  font-weight: 500;
  font-size: 0.65rem;
  padding: 2px 8px;
  border-radius: 999px;
  line-height: 1;
`;

const tagBase = css`
  height: 3.125rem;
  border-radius: 0 20px 20px 0;
  opacity: 1;
  margin-top: 0.65rem;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0 1rem;
  gap: 0.55rem;
  font-size: 0.85rem;
  line-height: 1.25;
  font-family: "roboto", sans-serif;
  letter-spacing: 0.25px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
  transition: background 0.2s ease, box-shadow 0.2s ease, transform 0.15s ease;
  &:hover {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.18),
      inset 0 0 0 1px rgba(255, 255, 255, 0.5);
    transform: translateY(-2px);
  }
  &:active {
    transform: translateY(0);
  }
  &:focus-visible {
    outline: 2px solid #1976d2;
    outline-offset: 2px;
  }
`;

export const TagColumn = styled.div`
  padding: 0.25rem 0.25rem 1rem;
  height: var(--tag-column-height, 460px);
  overflow: hidden;
  position: relative;
  display: flex;
  flex-direction: column;
  background: linear-gradient(#fafafa, #ffffff);
  border: 1px solid #ececec;
  border-radius: 10px;
  --tag-heading-height: 2.25rem;
`;

export const StoreTag = styled.div`
  ${tagBase};
  background: #ffdee6 0% 0% no-repeat padding-box;
`;

export const FlyerTag = styled.div`
  ${tagBase};
  background: #bee7ff 0% 0% no-repeat padding-box;
`;
export const FlyerParentTag = styled.div`
  ${tagBase};
  background: #bee7ff 0% 0% no-repeat padding-box;
  height: 3.375rem;
  padding: 0 0.75rem;
  gap: 0.5rem;
  & .flyer-index {
    font-size: 0.65rem;
    color: #555;
    font-weight: 500;
  }
  & .flyer-name {
    flex-grow: 1;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const MenuTag = styled.div`
  ${tagBase};
  background: #c3e1aa 0% 0% no-repeat padding-box;
`;

export const PromotionTag = styled.div`
  ${tagBase};
  background: #d9cbeb 0% 0% no-repeat padding-box;
`;

export const ProductTag = styled.div`
  ${tagBase};
  background: #fbddbc 0% 0% no-repeat padding-box;
`;

export const FigmaTemplateTag = styled.div`
  ${tagBase};
  background: #cfdcff 0% 0% no-repeat padding-box;
`;

export const ImageTag = styled.div`
  ${tagBase};
  background: #d4edda 0% 0% no-repeat padding-box;
`;

export const TagListBody = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;
  padding: 0.25rem 0.35rem 0.75rem 0.35rem;
  position: relative;
  box-shadow: inset 0 0 4px rgba(0, 0, 0, 0.06);
  border-radius: 8px;
  margin-top: 4px;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: #b5b5b5 transparent;
  & > *:first-child {
    margin-top: 0.35rem;
  }
  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background: #b5b5b5;
    border-radius: 3px;
  }
`;
